import { useEffect } from "react";
import { useNotifications } from "@/context/NotificationContext";
import { EmptyState } from "@/components/common/EmptyState";
import { Bell } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

export default function NotificationsPage() {
  const { items, markAllRead } = useNotifications();

  useEffect(() => {
    markAllRead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!items || items.length === 0) {
    return <EmptyState icon={Bell} title="No notifications yet" description="Job updates, messages and payments show up here." />;
  }

  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold bb-display">Notifications</h2>
      {items.map((n) => (
        <div key={n.id} className="rounded-xl border border-border bg-card p-3" data-testid="notification-item">
          <div className="text-sm font-medium capitalize">{n.event.replace(/_/g, " ")}</div>
          <div className="text-xs text-muted-foreground">
            {n.data && Object.entries(n.data).filter(([k]) => !["notification_id"].includes(k)).slice(0, 3).map(([k, v]) => (
              <span key={k} className="mr-2">{k}: {typeof v === "object" ? JSON.stringify(v).slice(0, 40) : String(v)}</span>
            ))}
          </div>
          <div className="text-[10px] text-muted-foreground mt-1">
            {(() => { try { return formatDistanceToNow(new Date(n.created_at), { addSuffix: true }); } catch { return ""; } })()}
          </div>
        </div>
      ))}
    </div>
  );
}
